export enum TipoFaturamentoEnum {
    Publico = 0,
    Privado = 1
}

export const TipoFaturamentoLabel: Record<TipoFaturamentoEnum, string> = {
    [TipoFaturamentoEnum.Publico]: "Público",
    [TipoFaturamentoEnum.Privado]: "Privado",    
};